import { StateContext } from "@ngxs/store";

import { IStateProcessor } from "../state-processor";
import { AppDataStateModel } from "@shared/models/app-data.model";
import { NgxsStoreHelpers } from "@shared/stores/store.helpers";
import { CommonSearchCriteria } from "@shared/models/common-data.model";
import { DefaultITToolUsage } from "@app/shared/models/it-tool-usage.model";

export class ITToolUsageStateProcessor implements IStateProcessor {
  GetDefaultSearchCriteria() {
    return DefaultITToolUsage.search.searchForm.model.searchCriteria;
  }

  SetSearchCriteria(ctx: StateContext<AppDataStateModel>, searchCriteria: CommonSearchCriteria[]) {
    NgxsStoreHelpers.SetItToolUsageSearchCriteria(ctx, searchCriteria);
  }

  AttachSearchCriteriaIntoCurrent(ctx: StateContext<AppDataStateModel>, newSearchCriteria: CommonSearchCriteria[]) {
    var currentSearchCriteria = ctx.getState().itToolUsage.search.searchForm.model.searchCriteria;
    this.SetSearchCriteria(ctx, [...newSearchCriteria, ...currentSearchCriteria]);
  }
}
